import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { MessageSourceProps, withMessages } from 'react-message-source';
import React, { useEffect, useState } from 'react';
import ToolbarButton from 'components/layout/ToolbarButton';
import { Icon } from 'semantic-ui-react';
import { PatientDto, TreatmentDto } from 'ts-types/api.types';
import { getTreatmentsByPatientIdAndDeleted } from 'services/treatmentServices';
import axios, { CancelTokenSource } from 'axios';

interface Props extends MessageSourceProps, AuthConsumerRenderProps {
  currentPatient?: PatientDto;
  onClick: (treatments: Array<TreatmentDto>) => void;
}

const TreatmentShowDeletedTreatmentsButton = (props: Props) => {
  const {currentPatient, onClick, getMessage} = props;

  const cancelTokenSource: CancelTokenSource = axios.CancelToken.source();

  const [showDeletedTreatments, setShowDeletedTreatments] = useState(true);
  const [selectedPatient, setSelectedPatient] = useState(undefined as PatientDto | undefined);

  useEffect(() => {

    if (selectedPatient) {
      if (currentPatient !== undefined && currentPatient.id !== selectedPatient.id) {
        setShowDeletedTreatments(!showDeletedTreatments);
      } else if (currentPatient !== undefined && currentPatient.id === selectedPatient.id){
        setShowDeletedTreatments(true);
      }
    }
    setSelectedPatient(currentPatient);
  }, [currentPatient]);


  const displayDeletedTreatments = async () => {
    const patientId = currentPatient ? currentPatient.id : undefined;

    const treatments = await getTreatmentsByPatientIdAndDeleted(patientId, showDeletedTreatments, cancelTokenSource);

    setShowDeletedTreatments(!showDeletedTreatments);

    onClick(treatments);
  }

  const buttonTooltip = showDeletedTreatments
      ? getMessage("treatment.show.deletedTreatment.message")
      : getMessage("treatment.hide.deletedTreatment.message");

  const iconColor = (showDeletedTreatments) ? "grey" : "red";

  return (
      <React.Fragment>
        <ToolbarButton
          iconName='file outline'
          iconSize='large'
          disabled={!currentPatient}
          onClick={displayDeletedTreatments}
          dataTooltip={buttonTooltip}
          customTrigger={(
              <Icon.Group size="large">
                <Icon name="file alternate outline" color={iconColor}/>
                <Icon corner="top right" name="trash alternate outline" color={iconColor} />
              </Icon.Group>
          )}
        />
      </React.Fragment>
  );
}

export default withMessages(withAuthContext(TreatmentShowDeletedTreatmentsButton));
